import { Image } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { ITastingNotesData } from './tasting-notes.data';
import { ITastingNotesProps } from './tasting-notes.props.autogenerated';

/**
 *
 * TastingNotes component
 * @extends {React.PureComponent<ITastingNotesProps<ITastingNotesData>>}
 */
class TastingNotes extends React.PureComponent<ITastingNotesProps<ITastingNotesData>> {

    private tastingNotesAttributeName: string = 'visual tasting notes';

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element | null {
        const content: ITastingNotesData = this.props.data;
        const productAttributes = content && content.productSpecificationData && content.productSpecificationData.result;
        const tastingNotes = productAttributes && productAttributes.find(
            attribute => attribute.Name && (attribute.Name.toLowerCase() === this.tastingNotesAttributeName)
        );
        if (tastingNotes) {
            const tastingNotesContent = this._getContent(tastingNotes);
            return (
                <div className='tasting-notes'>
                    {tastingNotesContent}
                </div>
            );
        }
        return null;
    }

    // =========================================================================
    // PRIVATE METHODS
    // =========================================================================

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _getContent(tastingNotes: AttributeValue | undefined): JSX.Element[] | null {
        if (tastingNotes && tastingNotes.TextValue) {
            const tastingNotesContent: JSX.Element[] = [];
            const tastingNotesList = tastingNotes.TextValue.replace(/\s/g, '').toLowerCase().split(',');
            tastingNotesList.forEach(note => {
                tastingNotesContent.push(
                    <div className='tasting-notes-item'>
                        {this._getImage(note)}
                    </div>
                );
            });
            return tastingNotesContent;
        }
        return null;
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _getImage(note: string): JSX.Element {
        return (
            <Image
                className='tasting-notes-image'
                gridSettings={this.props.context.request.gridSettings!}
                src={`${this.props.config.imageSearchUrl}tasting-note-${note}.png`}
                altText={note}
            />
        );
    }
}

export default TastingNotes;
